import axios from "axios";
import { Base_URL } from "../url";

/* ============================= */
/*        CREATE SPRINT         */
/* ============================= */

export const createSprint = async (sprintData) => {
  try {
    const response = await axios.post(
      `${Base_URL}/SprintProject/Create`,
      sprintData,
    );
    return response.data;
  } catch (error) {
    console.error("Error creating sprint:", error);
    throw error;
  }
};

/* ============================= */
/*        UPDATE SPRINT         */
/* ============================= */

export const updateSprint = async (sprintId, sprintData) => {
  try {
    const response = await axios.put(
      `${Base_URL}/SprintProject/Update/${sprintId}`,
      sprintData,
    );
    return response.data;
  } catch (error) {
    console.error(`Error updating sprint ${sprintId}:`, error);
    throw error;
  }
};

/* ============================= */
/*      GET SPRINT BY ORG       */
/* ============================= */

export const getSprintsByOrg = async (orgId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/SprintProject/GetByOrg/${orgId}`,
    );
    return response.data;
  } catch (error) {
    console.error(`Error fetching sprints for org ${orgId}:`, error);
    throw error;
  }
};

/* ===================================== */
/*   GET SPRINT BY ORG AND PROJECT      */
/* ===================================== */

export const getSprintsByOrgAndProject = async (orgId, projectId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/SprintProject/GetByOrgAndProject/${orgId}/${projectId}`,
    );
    return response.data;
  } catch (error) {
    console.error(
      `Error fetching sprints for org ${orgId} and project ${projectId}:`,
      error,
    );
    throw error;
  }
};

/* ============================= */
/*       MAP TASK TO SPRINT     */
/* ============================= */

export const mapTaskToSprint = async (payload) => {
  try {
    const response = await axios.post(
      `${Base_URL}/SprintProject/MapTask`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("Error mapping task to sprint:", error);
    throw error;
  }
};

/* ============================= */
/*      MAP TICKET TO SPRINT    */
/* ============================= */

export const mapTicketToSprint = async (payload) => {
  try {
    const response = await axios.post(
      `${Base_URL}/SprintProject/MapTicket`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("Error mapping ticket to sprint:", error);
    throw error;
  }
};

/* ============================= */
/*   GET TASKS BY SPRINT ID     */
/* ============================= */

export const getTasksBySprint = async (sprintId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/SprintProject/GetTasksBySprint/${sprintId}`,
    );
    return response.data;
  } catch (error) {
    console.error(`Error fetching tasks for sprint ${sprintId}:`, error);
    throw error;
  }
};

/* ============================= */
/*   GET TICKETS BY SPRINT ID   */
/* ============================= */

export const getTicketsBySprint = async (sprintId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/SprintProject/GetTicketsBySprint/${sprintId}`,
    );
    return response.data;
  } catch (error) {
    console.error(`Error fetching tickets for sprint ${sprintId}:`, error);
    throw error;
  }
};

/* ============================= */
/*    REMOVE TASK FROM SPRINT   */
/* ============================= */

export const removeTaskFromSprint = async (sprintId, taskId) => {
  try {
    const response = await axios.delete(
      `${Base_URL}/SprintProject/RemoveTask/${sprintId}/${taskId}`,
    );
    return response.data;
  } catch (error) {
    console.error("Error removing task from sprint:", error);
    throw error;
  }
};

/* ============================= */
/*   REMOVE TICKET FROM SPRINT  */
/* ============================= */

export const removeTicketFromSprint = async (sprintId, ticketId) => {
  try {
    const response = await axios.delete(
      `${Base_URL}/SprintProject/RemoveTicket/${sprintId}/${ticketId}`,
    );
    return response.data;
  } catch (error) {
    console.error("Error removing ticket from sprint:", error);
    throw error;
  }
};

export const getSprintSummary = async (orgId, projectId) => {
  const response = await axios.get(
    `${Base_URL}/SprintProject/GetSprintSummary/${orgId}/${projectId}`,
  );
  return response.data;
};
